import { render, staticRenderFns } from "./CompraTarjeta.vue?vue&type=template&id=51a0b54a&scoped=true"
import script from "./CompraTarjeta.vue?vue&type=script&lang=js"
export * from "./CompraTarjeta.vue?vue&type=script&lang=js"
import style0 from "./CompraTarjeta.vue?vue&type=style&index=0&id=51a0b54a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0b54a",
  null
  
)

export default component.exports